import React from 'react'

const OHPackageBanner = ({
  showContainer,
  showBanner,
  bannerImage,
  clickHereImage,
  onOpenPopup,
}) => {
  if (!showContainer) return null

  return (
    <div className="hidden lg:block w-44 xl:w-52 2xl:w-60 flex-shrink-0 z-50 relative">
      <div className="sticky top-8">
        <div className="relative">
          {showBanner ? (
            <div
              className="cursor-pointer"
              onClick={onOpenPopup}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault()
                  onOpenPopup()
                }
              }}
            >
              <img
                src={bannerImage}
                alt="Occupational Health Plus"
                className="w-full h-auto object-contain rounded-md shadow-lg bg-white"
              />
              <img
                src={clickHereImage}
                alt="Click here"
                className="absolute top-2 -right-[110px] xl:-right-[140px] w-24 xl:w-32 h-auto z-[70] pointer-events-auto cursor-pointer"
                onClick={onOpenPopup}
              />
            </div>
          ) : (
            <div className="w-full h-1" />
          )}
        </div>
      </div>
    </div>
  )
}

export default OHPackageBanner
